module.exports = __webpack_public_path__ + "static/media/covi_use_sta.cd6eebd0.png";